import { render, staticRenderFns } from "./Leftmenu_trc.vue?vue&type=template&id=0e976b91&scoped=true"
import script from "./Leftmenu_trc.vue?vue&type=script&lang=js"
export * from "./Leftmenu_trc.vue?vue&type=script&lang=js"
import style0 from "./Leftmenu_trc.vue?vue&type=style&index=0&id=0e976b91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e976b91",
  null
  
)

export default component.exports